import PropTypes from 'prop-types';

export const downShiftItemProptypes = {
  value: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired,
  content: PropTypes.node,
};
